import __request__ from "routing/request";
export function get(days = 30, daily = false, includeToday = true, requestOptions) {
  return __request__("GET", "/system/cluster/traffic", null, { "days": days, "daily": daily, "includeToday": includeToday }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
